import InternalCheckbox from './Checkbox';
import Group from './Group';
var Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.__ANT_CHECKBOX = true;
export default Checkbox;